import axios from "axios";
import {
  notRequiredAndText,
  requiredAndText,
  requiredAndTextMd,
  validarAfinazoneId,
  validarBool,
  validateNumberNotRequired,
  validatePrice,
  validateUPC
} from "helpers/validators";
const API_BASE_URL = `${process.env.REACT_APP_LARAVEL_API_HOST}/api`;
const TOKEN = process.env.REACT_APP_LARAVEL_API_TOKEN;

const LABELS_KAT = {
  0: "afinazone_id",
  1: "titulo",
  2: "transmision",
  3: "tipo_producto",
  4: "marca_auto",
  5: "modelo_auto",
  6: "anios_modelo",

  7: "volumen_cilindros",
  8: "cantidad_cilindros",
  9: "detalle_cilindros",

  10: "productos",
  11: "carter",
  12: "filtro",
  13: "junta",
  14: "o_ring",

  15: "precio",

  16: "introduccion",
  17: "contenido",
  18: "adicional",
  19: "compatibilidad",
  20: "final",

  21: "portada",
  22: "frente",
  23: "arriba",
  24: "abajo",

  25: "codigo_upc",
  26: "deshabilitar_aceite",
  27: "stock",
  28: "producto_recomendado",
  29: "variante_recomendada",
  30: "revision",
};


const FIELD_VALIDATORS = {
  afinazone_id: (value) => validarAfinazoneId(value),
  titulo: (value) => requiredAndText(value, 'titulo'),
  transmision: (value) => requiredAndText(value, 'transmisión'),
  tipo_producto: (value) => requiredAndText(value, 'tipo de producto'),
  marca_auto: (value) => requiredAndText(value, 'marca auto'),
  modelo_auto: (value) => requiredAndText(value, 'modelo auto'),
  anios_modelo: (value) => requiredAndText(value, 'años modelo'),

  volumen_cilindros: (value) => requiredAndText(value, 'volumen cilindros'),
  cantidad_cilindros: (value) => requiredAndText(value, 'cantidad cilindros'),
  detalle_cilindros: (value) => notRequiredAndText(value),

  productos: (value) => requiredAndText(value, 'productos'),
  carter: (value) => requiredAndText(value, 'carter'),
  filtro: (value) => notRequiredAndText(value),
  junta: (value) => notRequiredAndText(value),
  o_ring: (value) => notRequiredAndText(value),

  precio: (value) => validatePrice(value),

  introduccion: (value) => requiredAndTextMd(value, 'introducción'),
  contenido: (value) => requiredAndTextMd(value, 'contenido'),
  adicional: (value) => requiredAndTextMd(value, 'adicional'),
  compatibilidad: (value) => requiredAndTextMd(value, 'compatibilidad'),
  final: (value) => requiredAndTextMd(value, 'final'),

  portada: (value) => requiredAndText(value, 'portada'),
  frente: (value) => requiredAndText(value, 'frente'),
  arriba: (value) => requiredAndText(value, 'arriba'),
  abajo: (value) => requiredAndText(value, 'abajo'),

  codigo_upc: (value) => validateUPC(value),
  deshabilitar_aceite: (value) => validarBool(value),
  stock: (value) => validarBool(value),
  producto_recomendado: (value) => validarBool(value),
  variante_recomendada: (value) => validateNumberNotRequired(value),
  revision: (value) => validarBool(value),
};



export async function uploadNewCarterItems(data) {
  const errors = {};
  const validItems = [];

  data.forEach(item => {
    const afinazone_id = item[0];

    // Ignorar items sin ID válido
    if (afinazone_id === undefined || afinazone_id === null || afinazone_id === "") {
      return; // Saltar a la siguiente iteración
    }

    const result = createBody(item);

    if (!result.success) {
      if (!errors[afinazone_id]) errors[afinazone_id] = [];
      errors[afinazone_id].push(...result.errors);
    } else {
      validItems.push(result.body);
    }
  });

  if (Object.keys(errors).length > 0) {
    return {
      success: false,
      error: errors,
      message: "Errores de validación encontrados"
    };
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone/cart/bulk`,
      { items: validItems },
      {
        timeout: 60000,
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );

    console.log("✅ Items subidos con éxito:", response.data);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      console.error("⏳ Timeout: La solicitud tardó demasiado y fue cancelada");
      return { success: false, error: "Timeout: La solicitud tardó demasiado" };
    }

    console.error(
      "❌ Error en la subida:",
      error.response?.data || error.message
    );
    return { success: false, error: error.response?.data || error.message };
  }
}

function createBody(data) {

  if (data[0] === undefined || data[0] === "") return null;

  const body = {};
  const errors = [];

  // Validar cada campo
  for (const [index, value] of data.entries()) {
    const label = LABELS_KAT[index];
    if (!label) continue; // Si no existe el label, lo saltamos

    const validator = FIELD_VALIDATORS[label];
    if (!validator) {
      body[label] = value; // Si no hay validador, se asigna el valor crudo
      continue;
    }

    const result = validator(value);
    if (!result.valid) {
      errors.push({
        label,
        value,
        message: result.error
      });
    } else {
      body[label] = result.value;
    }
  }

  return {
    success: errors.length === 0,
    body: errors.length === 0 ? body : null,
    errors: errors.length > 0 ? errors : null
  };
}
